// extracted by mini-css-extract-plugin
export var content = "Content-module--content--68b59";
export var hasLead = "Content-module--hasLead--6dd85";